import dayjs from "dayjs";
export const formattedDate = (date: string | Date) =>
  dayjs(date).format('MMM DD, YYYY (hh:mm a | [EST])');
 